import React from 'react';
import { Badge, Modal, Spinner } from 'react-bootstrap';
import { Button } from '../Button';
import styled from 'styled-components';

const ConfigItem = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 12px 0;
  border-bottom: 1px solid #edf0f2;

  &:last-child {
    border-bottom: none;
  }
`;

const ConfigInfo = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
  min-width: 0;
`;

const ConfigTitle = styled.div`
  font-weight: 600;
  word-break: break-word;
`;

const BadgeRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
`;

const Actions = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
`;

const ConfiguracoesListagemModal = ({
  show,
  onClose,
  configs,
  loading,
  onSelecionar,
  onExcluir,
  loadingExcluirId
}) => (
  <Modal show={show} onHide={onClose} size="lg" animation={false} centered>
    <Modal.Header closeButton>
      <Modal.Title>Configuracoes salvas</Modal.Title>
    </Modal.Header>
    <Modal.Body>
      {loading ? (
        <div className="d-flex align-items-center gap-2">
          <Spinner animation="border" size="sm" />
          <span>Carregando configuracoes...</span>
        </div>
      ) : configs.length === 0 ? (
        <p className="mb-0">Nenhuma configuracao salva para esta tela.</p>
      ) : (
        configs.map((config) => (
          <ConfigItem key={config.id}>
            <ConfigInfo>
              <ConfigTitle>{config.nome}</ConfigTitle>
              <BadgeRow>
                {config.geral && <Badge bg="info">Geral</Badge>}
                {config.padrao && <Badge bg="primary">Padrao</Badge>}
              </BadgeRow>
            </ConfigInfo>
            <Actions>
              <Button
                variant="primary"
                size="sm"
                type="button"
                onClick={() => onSelecionar(config)}
              >
                Selecionar
              </Button>
              <Button
                variant="outline-danger"
                size="sm"
                type="button"
                disabled={!config.podeExcluir || loadingExcluirId === config.id}
                onClick={() => onExcluir(config)}
              >
                {loadingExcluirId === config.id ? 'Excluindo...' : 'Excluir'}
              </Button>
            </Actions>
          </ConfigItem>
        ))
      )}
    </Modal.Body>
    <Modal.Footer>
      <Button variant="secondary" type="button" onClick={onClose}>
        Fechar
      </Button>
    </Modal.Footer>
  </Modal>
);

export default ConfiguracoesListagemModal;
